import { useState } from 'react'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import ConfigDetailModal from 'features/RegulatoryTools/HCAMCA/Components/TabsAndModals/ConfigDetailModal'

const ConfigDetailButton = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <div className='flex'>
      <button
        className={[
          'flex',
          'items-center',
          'px-4',
          'text-gray-700',
          'font-medium',
          'leading-6'
        ].join(' ')}
        onClick={() => setIsModalOpen(true)}
      >
        <SettingsOutlinedIcon />
        <div className='ml-1 leading-6'>View Config</div>
      </button>
      <ConfigDetailModal
        closeModal={() => setIsModalOpen(false)}
        isModalOpen={isModalOpen}
      />
    </div>
  )
}

export default ConfigDetailButton
